<template>
  <v-select
    v-model="templateType"
    label="Document Type"
    :items="items"
    item-text="label"
    item-value="code"
    @change="onChange"
    :outlined="outlined"
  ></v-select>
</template>

<script>
export default {
  name: "document-type-select",

  props: {
    value: {
      type: String,
      default: () => "D",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      templateType: this.value ? this.value : "D",
      items: [
        { label: "Itinerary Document", code: "D" },
        { label: "Sales Invoice", code: "S" },
        { label: "Purchase Invoice", code: "P" },
        { label: "Voucher", code: "V" },
      ],
    };
  },

  watch: {
    value(newVal) {
      this.templateType = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.templateType);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/documents/DocumtTemplateTypeSelect.vue